import { FortuneTellingResult } from '../../../types/FortuneTellingResult';
import { ButtonText } from '../../Button/ButtonText';

import styles from './BlockInnerFortuneTelling.module.scss';

import type { FC } from 'react';

export type Props = {
  fortuneTellingResult: FortuneTellingResult;
};

export const BlockInnerFortuneTelling: FC<Props> = ({
  fortuneTellingResult,
}) => (
  <div className={styles.wrap}>
    <div className={styles['wrap-inner']}>
      <h2 className={styles['wrap-title']}>今日の運勢</h2>

      <div className={styles['wrap-point-block']}>
        <span className={styles['wrap-text']}>
          今日の{fortuneTellingResult.zodiacSignName}の運勢は
        </span>
        <span className={styles['wrap-point']}>
          <span className={styles.point}>{fortuneTellingResult.rank}</span>
          位/12位中
        </span>
        <div className={styles['wrap-button']}>
          <ButtonText
            color="default"
            link={fortuneTellingResult.detailUrl}
            useNextLink={true}
          >
            詳しくみる
          </ButtonText>
        </div>
      </div>
    </div>
  </div>
);
